var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heads'),_c('div',{class:[
    _vm.$route.meta.id == 10 || _vm.$route.meta.id == 59 ? ' cen' : ' ',
    _vm.$route.meta.id == 20 || _vm.$route.meta.id == 58 || _vm.$route.meta.id == 35 || _vm.$route.meta.id == 60 || _vm.$route.meta.id == 61 ? ' cent' : '',
    _vm.$route.meta.id == 17 ? ' cens' : '',
  ],style:({
    backgroundImage: 'url(' + require('@/assets/' + _vm.backgroud) + ')',
  })},[_c('div',{staticClass:"cen_box"},[_c('div',{class:[
        _vm.$route.meta.id == 17 ? 'cen-tops' : 'cen-top',
        _vm.$route.meta.id == 10 ? ' train' : ' ',
        _vm.$route.meta.id == 20 ? ' duomei' : ' ',
        _vm.$route.meta.id == 58 ? 'medicine' : '',
        _vm.$route.meta.id == 59 ? 'children-culture' : '',
        _vm.$route.meta.id == 35 || _vm.$route.meta.id == 60 ? 'literacy-chinese-character' : '',
      ]},[(_vm.$route.meta.id == 59 && _vm.videoList.length > 0)?_c('div',{staticClass:"link-wrap"},[_c('a',{staticClass:"i-item",attrs:{"href":"/video/childrenCulture/literacy"}},[_vm._v(" 字源识字 ")])]):_vm._e(),(_vm.$route.meta.id == 59 && _vm.videoList.length > 0)?_c('div',{staticClass:"link-wrap"},[_c('a',{staticClass:"i-item",attrs:{"href":"/video/childrenCulture/chineseCharacter"}},[_vm._v(" 汉字动画 ")])]):_vm._e(),_vm._l((_vm.videoList),function(item,index){return _c('div',{key:index,staticClass:"link-wrap"},[_c('router-link',{staticClass:"i-item",attrs:{"to":item.link_url != '' && item.link_url != null ? item.link_url : {
            path: _vm.pathUrl,
            query: { id: item.id },
          }}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)})],2)])]),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }